import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { APIOperationResult } from '../_models/apioperation-result';
import { NewUserRequestModel } from '../_models/new-user-request-model';
import { ResetPasswordArgs } from '../_models/reset-password-args';
import { User } from '../_models/user';
import { OperatorModel } from '../_models/operator-model';
import { ValidateEmailRequestArgs } from '../_models/validate-email-request-args';
import { ValidateEmailResponse } from '../_models/validate-email-response';
import { UserOperatorModel } from '../_models/user-operator-model';
import { OperatorApprovedUsersModel } from '../_models/operator-approved-users-model';
import { SafeUser } from '../_models/safe-user';

import { UserPrefsModel } from '../_models/user-prefs-model';
import { UserPrefsExchangeModel } from '../_models/user-prefs-exchange-model';

@Injectable({
  providedIn: 'root'
})
export class UserAccountService {

  isSubmitNewUserWorking: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isConfirmUserWorking: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isApproveUserWorking: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isChangePasswordWorking: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isResetPasswordWorking: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isGetMyUserPrefsWorking: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isFetchOperatorsForUserWorking: BehaviorSubject<Boolean> = new BehaviorSubject<Boolean>(false);
  public isFetchMyApprovedUsersWorking: BehaviorSubject<Boolean> = new BehaviorSubject<Boolean>(false);

  constructor(protected httpClient: HttpClient) {

  }

  public validateEmail(email: string): Promise<any> {

    var validateEmailApiUrl = "api/Users/ValidateEmail";

    var args: ValidateEmailRequestArgs = new ValidateEmailRequestArgs();
    args.email = email;

    return <Promise<any>> this.httpClient.post(validateEmailApiUrl, args).toPromise();
  }

  public submitNewUser(newUserModel: NewUserRequestModel): Promise<APIOperationResult> {

    var prom = new Promise<APIOperationResult>((resolve, reject) => {
      this.isSubmitNewUserWorking.next(true);

      var url = "api/Users/Register";

      this.httpClient.post(url, newUserModel).toPromise().then((result: APIOperationResult) => {
        this.isSubmitNewUserWorking.next(false);

        resolve(result);
      },
      (err) => {
        this.isSubmitNewUserWorking.next(false);
        reject(err);
      });

    });

    return prom;
  }

  public adminSubmitNewUser(newUserModel: NewUserRequestModel): Promise<APIOperationResult> {
    var prom = new Promise<APIOperationResult>((resolve, reject) => {
      this.isSubmitNewUserWorking.next(true);

      var url = "api/Users/admin/new";

      this.httpClient.post(url, newUserModel).toPromise().then((result: APIOperationResult) => {
        this.isSubmitNewUserWorking.next(false);

        resolve(result);
      },
      (err) => {
        this.isSubmitNewUserWorking.next(false);
        reject(err);
      });

    });

    return prom;
  }

  public confirmUser(userId: number, confirmationCode: string) {
    var prom = new Promise<APIOperationResult>((resolve, reject) => {

      this.isConfirmUserWorking.next(true);

      var url = "api/Users/userconfirm/" + userId.toString() + "/" + confirmationCode;

      this.httpClient.get(url).toPromise().then((result: APIOperationResult) => {
        this.isConfirmUserWorking.next(false);
        resolve(result);
      },
        (err) => {
          this.isConfirmUserWorking.next(false);
        reject(err);
      });
    });

    return prom;
  }

  public approverConfirmUser(userId: number, operatorId: number, confirmationCode: string, approve: string) {
    var prom = new Promise<APIOperationResult>((resolve, reject) => {

      this.isApproveUserWorking.next(true);

      var url = "api/Users/approverconfirm/" + userId.toString() + "/" + operatorId.toString() + "/" + confirmationCode + "/" + approve;

      this.httpClient.get(url).toPromise().then((result: APIOperationResult) => {
        this.isApproveUserWorking.next(false);
        resolve(result);
      },
        (err) => {
          this.isApproveUserWorking.next(false);
          reject(err);
        });
    });

    return prom;
  }

  public getFullAccountDetails(userId: number): Promise<User> {
    var prom = new Promise<User>((resolve, reject) => {

    });

    return prom;
  }

  public changePassword(userId: number, oldPassword: string, newPassword: string): Promise<APIOperationResult> {
    var prom = new Promise<APIOperationResult>((resolve, reject) => {
      this.isChangePasswordWorking.next(true);
      var url = "api/Users/" + userId.toString() + "/changepassword";

      var args = {
        oldPassword: oldPassword,
        newPassword: newPassword
      };

      this.httpClient.post(url, args).subscribe((result: APIOperationResult) => {
        this.isChangePasswordWorking.next(false);

        resolve(result);
      },
      (err) => {
        this.isChangePasswordWorking.next(false);
        reject(err);
      });
    });

    return prom;
  }

  public resetPasssword(resetArgs: ResetPasswordArgs): Promise<APIOperationResult> {
    var prom = new Promise<APIOperationResult>((resolve, reject) => {
      this.isResetPasswordWorking.next(true);
      var url = "api/Users/resetpassword";

      this.httpClient.post(url, resetArgs).subscribe((result: APIOperationResult) => {
        this.isResetPasswordWorking.next(false);

        resolve(result);
      },
        (err) => {
          this.isResetPasswordWorking.next(false);
          reject(err);
        });
    });

    return prom;
  }


  requestNewOperatorsForUser(userId: number, operatorIds: Array<number>) {

    var reqBody = {
      userId: userId,
      operatorIds: operatorIds
    };

    var url = "api/Users/requestnewoperators";

    var prom = new Promise<Object>((resolve, reject) => {
      this.httpClient.post(url, reqBody).toPromise().then(() => {
        resolve(null);
      },
        (err) => {
          reject();
        });
    });

    return prom;
  }


  fetchOperatorsForUser(userId: number): Promise<Array<UserOperatorModel>> {
    var url = "api/Users/" + userId + "/operators";

    var prom = new Promise<Array<UserOperatorModel>>((resolve, reject) => {

      this.isFetchOperatorsForUserWorking.next(true);

      this.httpClient.get(url).toPromise().then((result: Array<UserOperatorModel>) => {
        this.isFetchOperatorsForUserWorking.next(false);

        resolve(result);
      },
        (err) => {
          this.isFetchOperatorsForUserWorking.next(false);
          reject();
        });
    });

    return prom;
  }

  fetchMyApprovedUsers(): Promise<Array<OperatorApprovedUsersModel>> {
    var url = "api/Users/myapproved";

    var prom = new Promise<Array<OperatorApprovedUsersModel>>((resolve, reject) => {
      this.isFetchMyApprovedUsersWorking.next(true);

      this.httpClient.get(url).toPromise().then((result: Array<OperatorApprovedUsersModel>) => {
        this.isFetchMyApprovedUsersWorking.next(false);

        resolve(result);
      },
        (err) => {
          this.isFetchMyApprovedUsersWorking.next(false);
      });
    });

    return prom;
  }

  fetchSafeUser(userId: number, operatorId: number) {
    var url = "api/Users/" + userId + "/" + operatorId + "/safe";

    var prom = new Promise<Array<SafeUser>>((resolve, reject) => {
      //this.isFetchMyApprovedUsersWorking.next(true);

      this.httpClient.get(url).toPromise().then((result: Array<SafeUser>) => {
        //this.isFetchMyApprovedUsersWorking.next(false);

        resolve(result);
      },
        (err) => {
          //this.isFetchMyApprovedUsersWorking.next(false);
        });
    });

    return prom;
  }

  fetchAllUsers(): Promise<Array<SafeUser>> {
    var url = "api/Users/allusers";

    var prom = new Promise<Array<SafeUser>>((resolve, reject) => {
      //this.isFetchMyApprovedUsersWorking.next(true);

      this.httpClient.get(url).toPromise().then((result: Array<SafeUser>) => {
        //this.isFetchMyApprovedUsersWorking.next(false);

        resolve(result);
      },
        (err) => {
          //this.isFetchMyApprovedUsersWorking.next(false);
        });
    });

    return prom;
  }

  adminFetchUser(userId: number) {
    var url = "api/Users/admin/" + userId;

    var prom = new Promise<SafeUser>((resolve, reject) => {
      //this.isFetchMyApprovedUsersWorking.next(true);

      this.httpClient.get(url).toPromise().then((result: SafeUser) => {
        //this.isFetchMyApprovedUsersWorking.next(false);

        resolve(result);
      },
        (err) => {
          reject(err);
          //this.isFetchMyApprovedUsersWorking.next(false);
        });
    });

    return prom;
  }

  adminUpdateUser(userAttrs: any) {
    var url = "api/Users/admin/" + userAttrs.Id;

    var prom = new Promise<SafeUser>((resolve, reject) => {
      //this.isFetchMyApprovedUsersWorking.next(true);

      this.httpClient.post(url, userAttrs).toPromise().then((result: SafeUser) => {
        //this.isFetchMyApprovedUsersWorking.next(false);

        resolve(result);
      },
        (err) => {
          reject(err);
          //this.isFetchMyApprovedUsersWorking.next(false);
        });
    });

    return prom;
  }

  resendConfirmationEmail(userId: number) {
    var url = "api/Users/ResendConfirmation/" + userId;

    var prom = new Promise<null>((resolve, reject) => {
      this.httpClient.get(url).toPromise().then((result: any) => {
        resolve(result);
      },
      (err) => {
        reject(err);
      });
    });

    return prom;
  }

  getMyUserPrefs() {
    var url = "api/Users/myprefs";

    var prom = new Promise<UserPrefsExchangeModel>((resolve, reject) => {
      this.isGetMyUserPrefsWorking.next(true);

      this.httpClient.get(url).toPromise().then((result:UserPrefsExchangeModel) => {
        this.isGetMyUserPrefsWorking.next(false);

        let userPrefs = null;

        if(result.SerializedUserPrefs != null)
        {
          userPrefs = JSON.parse(result.SerializedUserPrefs);
        }

        if(userPrefs == null || userPrefs == undefined) {
          userPrefs = new UserPrefsModel();
        }

        resolve(userPrefs);
      },
        (err) => {
          reject();
          this.isGetMyUserPrefsWorking.next(false);
      });
    });

    return prom;
  }

  saveMyUserPrefs(userPrefs: UserPrefsModel) {
    var url = "api/Users/myprefs";

    let requestModel = new UserPrefsExchangeModel();

    requestModel.SerializedUserPrefs = JSON.stringify(userPrefs);

    var prom = new Promise<void>((resolve, reject) => {
      let p = this.httpClient.post(url, requestModel).toPromise();

      p.then(() => {
        resolve();
      },
      (err) => {
        reject();
      });
    });

    return prom;
  }
}
